import type { OperatorTabletProps } from "./operator-tablet-contract";
import { useOperatorTabletWorkspace } from "./useOperatorTabletWorkspace";
import { OperatorTabletView } from "./OperatorTabletView";

export function OperatorTablet(props: OperatorTabletProps) {
  const workspace = useOperatorTabletWorkspace(props);
  return <OperatorTabletView {...workspace} />;
}

export type { OperatorTabletProps } from "./operator-tablet-contract";
